import {stringify} from 'qs'
import request from 'message-control/utils/request'
import api from './api'

export async function getList(payload) {
    return request(`${api.getList.url}?${stringify(payload?.params)}`)
}

export async function getUpdateTime(payload) {
    return request(`${api.getUpdateTime.url}?${stringify(payload?.params)}`)
}

export async function getExportData(payload) {
    return request(`${api.getExport.url}?${stringify(payload?.params)}`, {}, {returnResponse: true})
}
